interface IAndroidWebViewApi {
    /** Trigger WebView Event. This will also hide the loading animation in WebView */
    onFinishLoaded(): void

    /** Trigger WebView to update stored cookies */
    updateCookies(): void

    /** Trigger when location.pathname changed */
    onPathnameChanged(pathname: string): void

    /** Trigger toggle fullscreen in WebView App */
    toggleFullscreen(): void
}

const owAndroidObject = (window as any).OwAndroid as IAndroidWebViewApi

const androidWebViewApi = {
    updateCookies() {
        owAndroidObject?.updateCookies()
    },
    onFinishLoaded() {
        owAndroidObject?.onFinishLoaded()
    },
    onPathnameChanged(pathname: string) {
        owAndroidObject?.onPathnameChanged(pathname)
    },
    toggleFullscreen() {
        owAndroidObject?.toggleFullscreen()
    },
    isRunInAndroidWebView() {
        return Boolean(owAndroidObject)
    },
}

export default androidWebViewApi
